import { makeStyles } from "@material-ui/core/styles";

const MxStyles = makeStyles(theme => ({
    spinner: {
        marginTop: theme.spacing(4),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        position: "relative",
        zIndex: 9999
    },
    formControl: {
        minWidth: "100%"
    },
    form: {}
}));

export default MxStyles;
